import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/ExamSession`;

const ExamSessionServices = {
    getExamOfYear: async () => {
        try {
            const response = await axios.get(`${API_URL}/GetExamOfYear`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching exam session`, error);
            throw error;
        }
    },
    getNewExam: async () => {
        try {
            const response = await axios.get(`${API_URL}/GetNewExam`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching exam session`, error);
            throw error;
        }
    },


};

export default ExamSessionServices;